import {AppComponent} from '../components/app.component';
import { EventEmitter, Injectable } from '@angular/core';
import { CommandsService } from './commands.service';

// #########################################################################
//
// This service is used to keep track of all information about the editor. 
//
// #########################################################################

declare var ace:any;

export class EditorContentService {
  
  private editorText: string[];
  public onEditorFocus;
  //public editor: any;
  public currentIndexTabs;
  public tabs: HTMLAnchorElement[];

  private styleRef;
  private close;

  // Variables related to adding and removing tabs
  private currentHighlightTab;

  // Used to check wether editor is in debug mode or not
  private debugExecution = false;

  constructor() {
    this.editorText = [];
    this.onEditorFocus = false;
  }

  public getDebugMode() {
      return this.debugExecution;
  }

  public getDebugToggleButton() {
    return document.getElementById('debugToggleButton');
  }

  public getDebugToggleSwitch() {
    return document.getElementById('debugToggleSwitch');
  }

  public getPrevButton() {
      return document.getElementById('prevButton');
  }

  public getNextButton() {
      return document.getElementById('nextButton');
  }

  public disableButton(button) {
      button.disabled = true;
  }

  public enableButton(button) {
    button.disabled = false;
  }

    // Shows button to step forward
  // TODO: only show history if there are multiple commands
  public showDebugElements() {
    console.log('[ECSV] Entering debug mode');
    let debugWatch = document.getElementById('debugWatch');
    let prevButton = document.getElementById('prevButton');
    let nextButton = document.getElementById('nextButton');
    debugWatch.style.display = 'block';
    prevButton.classList.remove('hidden');
	nextButton.classList.remove('hidden');
  }

  // hide step-wise buttons: prev and next
  public hideDebugElements() {
    console.log('[ECSV] Exiting debug mode\n');
    let debugWatch = document.getElementById('debugWatch');
    let prevButton = document.getElementById('prevButton');
    let nextButton = document.getElementById('nextButton');
    debugWatch.style.display = 'none';
    prevButton.classList.add('hidden');
	nextButton.classList.add('hidden');
	
	this.enableButton(this.getDebugToggleButton());
	this.enableButton(this.getDebugToggleSwitch());
  }

  // hide all buttons related to debugging
  public hideDebugFunctionality() {
    let debugToggle = document.getElementById('debugToggleButton');
    let prevButton = document.getElementById('prevButton');
    let nextButton = document.getElementById('nextButton');
    debugToggle.classList.add('hidden');
    prevButton.classList.add('hidden');
    nextButton.classList.add('hidden');
  }

  public   prepareEditorTabContentForSaving(): string{
    //make sure recent changes are registered in editor
    this.editorText["K" + this.currentIndexTabs] = AppComponent.editor.getValue();

    //separate different tabs by adding separator "$"
    let text = '';
    for (let key in this.editorText) {
      let value = this.editorText[key];
      text = text + value + ' $';
    }

    //remove last '$' so there is no emty last tab
    text = text.substring(0, text.length - 1);

    return text;
  }
  
  //download text as file with a given fileName
  public downloadFile(filename, text) {
      var pom = document.createElement('a');
      pom.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      pom.setAttribute('download', filename);
  
      if (document.createEvent) {
          var event = document.createEvent('MouseEvents');
          event.initEvent('click', true, true);
          pom.dispatchEvent(event);
      }
      else {
          pom.click();
      }
  }

  public prepareTabs(){
    // load tabs (K1 and + in the beginning), where K1 has no x
    let u = <HTMLAnchorElement>document.getElementById('K1');
    let v = <HTMLAnchorElement>document.getElementById('plus');
    this.editorText['K1'] = '';
    AppComponent.editor.setValue(this.editorText['K1'], 1);
    this.tabs = [u, v];
    (<HTMLAnchorElement>this.tabs[0].parentElement.children[1]).style.display = 'none';

    this.styleRef = document.defaultView.getComputedStyle(document.getElementById('listitem'), '').cssText;
    this.close = document.getElementById('x');

    // choose anchor element k1 when clicked
    u.onclick = function(event) {
      this.click(event);
    }.bind(this);

    // dieser wert sollte überschrieben werden, wenn man editor lädt
    this.currentIndexTabs = 1;
    this.currentHighlightTab = 'K1';
  }

  public toggleDebug() {
    this.debugExecution = !this.debugExecution;

    // indicate debug mode by setting toggle colors
    const toggleSwitch = <HTMLInputElement> this.getDebugToggleSwitch();
    toggleSwitch.checked = this.debugExecution;

    // Switch focus to input line
    ace.edit('inputEditor').focus();

    console.log('[ECSV] Debug is on: ', this.debugExecution);
  }

  public addTab(saveOldContent: boolean) {

    // save current content of editor
    if(saveOldContent){
      this.editorText[this.currentHighlightTab] = AppComponent.editor.getValue();
    }

    this.currentIndexTabs++;
    this.currentHighlightTab = 'K' + (this.currentIndexTabs);

    // prepare elements
    let ul = document.getElementById('tabs');
    let li = document.createElement('li');
    let a = document.createElement('a');

    // define text on new tab to be K+ {current tab index}
    a.appendChild(document.createTextNode(this.currentHighlightTab));

    // remove last element, so it can be appended after new element again
    let plus = document.getElementById('plusListItem');
    let plusA = <HTMLAnchorElement>document.getElementById('plus');
    ul.removeChild(plus);
    this.tabs.pop();

    // define properties and visuals of the new tab
    a.setAttribute('id', this.currentHighlightTab);
    a.onclick = function(event) {
      this.click(event);
    }.bind(this);
    li.appendChild(a);
    li.style.cssText = this.styleRef;
    li.style['margin'] = '0px 5px 0px 0px';
    li.style['width'] = 'inherit';

    // prepare Editor and save old editor
    this.editorText['K' + (this.currentIndexTabs)] = '';
    AppComponent.editor.setValue(this.editorText[this.currentHighlightTab], 1);

    // define id and color style for close sign
    let closeTemp = this.close.cloneNode(true);
    closeTemp.className = 'arrow';
    closeTemp.setAttribute('id', 'C' + (this.currentIndexTabs));

    // on click, remove tab from tabs
    closeTemp.onclick = function(event) {
      this.closeEditor(event);
    }.bind(this);

    // on hover: icon red and color white
    closeTemp.onmouseover = function() {
      closeTemp.style.cssText = '';
      closeTemp.className = 'arrowhover';
      closeTemp.setAttribute('background-color', '#aa0a00');
    }.bind(this);

    closeTemp.onmouseout = function() {
      closeTemp.style.cssText = '';
      closeTemp.className = 'arrow';
      closeTemp.setAttribute('color', 'gray');
    }

    li.appendChild(closeTemp);

    // append it to parent and register it at tabs array
    ul.appendChild(li);
    this.tabs.push(a);

    // highlight last entry only
    for (let i = 0; i < this.tabs.length; i++) {
      this.tabs[i].style['background-color'] = '#EEEEEE';
    }
    this.tabs[this.tabs.length - 1].style['background-color'] = 'burlywood';

    // add plus again at last position
    ul.appendChild(plus);
    this.tabs.push(plusA);

    // make sure first tab can be removed
    if (this.tabs.length === 3) {
      for (let i = 0; i < this.tabs.length - 1; i++) {
        (<HTMLAnchorElement>this.tabs[i].parentElement.children[1]).style.display = 'inherit';
      }

      // on click, remove tab from tabs
      (<HTMLAnchorElement>this.tabs[0].parentElement.children[1]).onclick = function(event) {
         this.closeEditor(event);
      }.bind(this);
    }
  }
  
    // remove tab from current editor
  closeEditor(event) {
    // make sure we have always at least one tab left (the last tab is used to create new tabs)
    if (this.tabs.length > 2) {
      // get the reference to the according tab element
      let target = event.target || event.srcElement || event.currentTarget;
      let idAttr = target.attributes.id;
      let id = idAttr.nodeValue;
      let a = document.getElementById(id);
      let li = a.parentElement;

      // remove the tab from the list of all tabs
      let ul = document.getElementById('tabs');
      ul.removeChild(li);

      // remove the element from the tabs array
      let index = this.tabs.indexOf(<HTMLAnchorElement>(li.children[0]));
      if (index > -1) {
        this.tabs.splice(index, 1);
      }

      // remove the element (editor entry) from editorText
      delete this.editorText[li.children[0].id];

      // mark the first element to be active
      for (let i = 0; i < this.tabs.length - 1; i++) {
        this.tabs[i].style['background-color'] = '#EEEEEE';
      }
      this.tabs[0].style['background-color'] = 'burlywood';
      AppComponent.editor.setValue(this.editorText[this.tabs[0].id], 1);

      // set first tab to be acive
      this.currentHighlightTab = this.tabs[0].id;
    }

    // if only one tab remaining remove x from this tab
    if (this.tabs.length <= 2) {
      (<HTMLAnchorElement> this.tabs[0].parentElement.children[1]).style.display = 'none';
    }

  }

  // if a tab was clicked on
  click(event) {
    // deactivate all other tabs
    for (let i = 0; i < this.tabs.length - 1; i++) {
      this.tabs[i].style['background-color'] = '#EEEEEE';
    }

    // mark this tab as active
    let target = event.target || event.srcElement || event.currentTarget;
    let idAttr = target.attributes.id;
    let id = idAttr.nodeValue;
    let a = document.getElementById(id);
    a.style['background-color'] = 'burlywood';

    // save current content of editor
    this.editorText[this.currentHighlightTab] = AppComponent.editor.getValue();

    // load editor content
    AppComponent.editor.setValue(this.editorText[id], 1);

    this.currentHighlightTab = id;
  }

  //##################################################################################
  //These are dummy implementations to make compiler run through. Proper integarteion work needed.
  //##################################################################################
  
  public textInDisplayNeedsChangeEmitter: EventEmitter<void> = new EventEmitter<void>();
  public editorEnabler: EventEmitter<boolean> = new EventEmitter<boolean>();

  public getCurrentEditorText(): string {
   // return this.editorText;
   return "TODO";
  }

  public setTextOfCurrentEditorProgrammatically(val: string) {
    //this.editorText = val;
    this.textInDisplayNeedsChangeEmitter.emit();
  }

  public setTextOfCurrentEditorFromDisplay(val: string) {
    //this.editorText = val;
    //this.textInDisplayHasChangedEmitter.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/services/editorcontent.service.ts